// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2394a3b8%27 stroke-width=%272%27%3E%3Ccircle cx=%2711%27 cy=%2711%27 r=%278%27/%3E%3Cpath d=%27m21 21-4.35-4.35%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Admin Instructor Approval Styles — Dark Data-Dashboard Theme ===== */

/* Stats Grid */
.admin-instructor__stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}

.admin-instructor__stat-card {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: 12px;
  padding: 16px;
  transition: all 0.2s;
}

.admin-instructor__stat-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  transform: translateY(-2px);
}

.admin-instructor__stat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.admin-instructor__stat-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-instructor__stat-icon--warning {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-instructor__stat-icon--success {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-instructor__stat-icon--primary {
  background: rgba(167, 139, 250, 0.1);
  color: #a78bfa;
}

.admin-instructor__stat-icon--info {
  background: var(--admin-info-bg);
  color: var(--admin-info);
}

.admin-instructor__stat-label {
  font-size: 12px;
  color: var(--admin-text-muted);
  margin-bottom: 4px;
}

.admin-instructor__stat-value {
  font-size: 24px;
  font-weight: 700;
  color: var(--admin-text-primary);
}

/* Tabs */
.admin-instructor__tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
  padding: 3px;
  background: var(--admin-surface);
  border-radius: 10px;
  width: fit-content;
}

.admin-instructor__tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  background: transparent;
  cursor: pointer;
  transition: all 0.2s;
}

.admin-instructor__tab:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-primary);
}

.admin-instructor__tab--active {
  background: var(--admin-border);
  color: var(--admin-text-primary);
}

.admin-instructor__tab--active:hover {
  background: var(--admin-border);
  color: var(--admin-text-primary);
}

.admin-instructor__tab-badge {
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  background: var(--admin-surface-hover);
  color: var(--admin-text-secondary);
}

.admin-instructor__tab--active .admin-instructor__tab-badge {
  background: rgba(167, 139, 250, 0.2);
  color: inherit;
}

/* Card Container */
.admin-instructor__card-container {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: 12px;
  overflow: hidden;
}

.admin-instructor__card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-instructor__card-title {
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--admin-text-primary);
}

.admin-instructor__card-body {
  padding: 20px;
}

/* Search Input */
.admin-instructor__search-input {
  width: 250px;
  padding: 8px 12px 8px 36px;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  font-size: 13px;
  color: var(--admin-text-primary);
  background: var(--admin-bg) url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 10px center no-repeat;
  transition: all 0.2s;
}

.admin-instructor__search-input:focus {
  outline: none;
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);
}

.admin-instructor__search-input::placeholder {
  color: var(--admin-text-muted);
}

/* Instructor Cards */
.admin-instructor__card {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  transition: all 0.2s;
}

.admin-instructor__card:last-child {
  margin-bottom: 0;
}

.admin-instructor__card:hover {
  border-color: var(--admin-text-dim);
}

.admin-instructor__card--pending {
  border-left: 2px solid var(--admin-warning);
}

.admin-instructor__card--approved {
  border-left: 2px solid var(--admin-success);
}

.admin-instructor__card--rejected {
  border-left: 2px solid var(--admin-error);
}

.admin-instructor__card .admin-instructor__card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 0;
  border: none;
  background: transparent;
}

.admin-instructor__profile {
  display: flex;
  align-items: center;
  gap: 14px;
}

.admin-instructor__avatar {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--admin-border), var(--admin-text-dim));
  color: var(--admin-text-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}

.admin-instructor__avatar--approved {
  background: linear-gradient(135deg, var(--admin-success), #22c55e);
  color: var(--admin-bg);
}

.admin-instructor__avatar--rejected {
  background: linear-gradient(135deg, var(--admin-text-muted), var(--admin-text-dim));
  color: var(--admin-text-primary);
}

.admin-instructor__name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
}

.admin-instructor__info h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--admin-text-primary);
  margin: 0;
}

.admin-instructor__role-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
}

.admin-instructor__role-badge--partner {
  background: rgba(167, 139, 250, 0.15);
  color: #a78bfa;
}

.admin-instructor__role-badge--assistant {
  background: var(--admin-info-bg);
  color: var(--admin-info);
}

.admin-instructor__info p {
  font-size: 13px;
  color: var(--admin-text-muted);
  margin: 0;
}

.admin-instructor__status-badge {
  padding: 5px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
}

.admin-instructor__status-badge--pending {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-instructor__status-badge--approved {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-instructor__status-badge--rejected {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

/* Details */
.admin-instructor__details {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  padding: 14px;
  background: var(--admin-bg);
  border-radius: 8px;
}

.admin-instructor__details--has-actions {
  margin-bottom: 16px;
}

.admin-instructor__detail-item {
  text-align: center;
}

.admin-instructor__detail-label {
  font-size: 11px;
  color: var(--admin-text-muted);
  margin-bottom: 4px;
}

.admin-instructor__detail-value {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-instructor__detail-value--success {
  color: var(--admin-success);
}

.admin-instructor__detail-value--error {
  color: var(--admin-error);
}

.admin-instructor__field-tag {
  display: inline-block;
  padding: 3px 8px;
  background: var(--admin-info-bg);
  color: var(--admin-info);
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
}

/* Actions */
.admin-instructor__actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid var(--admin-border);
}

.admin-instructor__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.admin-instructor__btn--success {
  background: var(--admin-success);
  color: var(--admin-bg);
}

.admin-instructor__btn--success:hover {
  background: #22c55e;
  box-shadow: 0 4px 12px var(--admin-success-bg);
}

.admin-instructor__btn--danger {
  background: var(--admin-error);
  color: #fff;
  border: none;
}

.admin-instructor__btn--danger:hover {
  background: #ef4444;
  box-shadow: 0 4px 12px var(--admin-error-bg);
}

.admin-instructor__btn--secondary {
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  color: var(--admin-text-primary);
}

.admin-instructor__btn--secondary:hover {
  background: var(--admin-surface-hover);
  border-color: var(--admin-text-dim);
}

/* Rejection Reason */
.admin-instructor__reject-reason {
  margin-top: 16px;
  padding: 12px;
  background: var(--admin-error-bg);
  border: 1px solid rgba(248, 113, 113, 0.2);
  border-radius: 8px;
}

.admin-instructor__reject-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--admin-error);
  margin-bottom: 4px;
}

.admin-instructor__reject-text {
  font-size: 13px;
  color: var(--admin-text-secondary);
  line-height: 1.5;
}

/* Empty State */
.admin-instructor__empty-state {
  text-align: center;
  padding: 60px 20px;
}

.admin-instructor__empty-icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;
  color: var(--admin-text-muted);
  stroke-width: 1.5;
  stroke: currentColor;
  fill: none;
}

.admin-instructor__empty-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--admin-text-secondary);
  margin-bottom: 8px;
}

.admin-instructor__empty-desc {
  font-size: 13px;
  color: var(--admin-text-muted);
}

/* Modal */
.admin-instructor__modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-instructor__modal {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: 16px;
  width: 100%;
  max-width: 480px;
  overflow: hidden;
}

.admin-instructor__modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-instructor__modal-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-instructor__modal-close {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--admin-text-secondary);
  transition: all 0.2s;
}

.admin-instructor__modal-close:hover {
  background: var(--admin-border);
  color: var(--admin-text-primary);
}

.admin-instructor__modal-body {
  padding: 24px;
}

.admin-instructor__modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--admin-border);
}

/* Form Elements */
.admin-instructor__form-group {
  margin-bottom: 16px;
}

.admin-instructor__form-group:last-child {
  margin-bottom: 0;
}

.admin-instructor__form-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  margin-bottom: 6px;
}

.admin-instructor__form-input,
.admin-instructor__form-select {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  font-size: 14px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  transition: all 0.2s;
}

.admin-instructor__form-input:focus,
.admin-instructor__form-select:focus {
  outline: none;
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);
}

.admin-instructor__form-textarea {
  width: 100%;
  min-height: 100px;
  padding: 10px 14px;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  font-size: 14px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  font-family: inherit;
  resize: vertical;
  transition: all 0.2s;
}

.admin-instructor__form-textarea:focus {
  outline: none;
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);
}

.admin-instructor__form-textarea::placeholder {
  color: var(--admin-text-muted);
}

.admin-instructor__role-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.admin-instructor__role-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.admin-instructor__role-option:hover {
  border-color: #a78bfa;
  background: rgba(167, 139, 250, 0.05);
}

.admin-instructor__role-option input[type="radio"] {
  accent-color: #a78bfa;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.admin-instructor__role-option-label {
  font-size: 14px;
  color: var(--admin-text-primary);
  cursor: pointer;
}

.admin-instructor__warning-box {
  padding: 12px;
  background: var(--admin-warning-bg);
  border: 1px solid rgba(251, 146, 60, 0.25);
  border-radius: 8px;
  font-size: 12px;
  color: var(--admin-warning);
}
`, "",{"version":3,"sources":["webpack://./src/css/AdminInstructorApproval.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,yFAAgS;EAChS,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+EAA+E;EAC/E,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kEAAkE;EAClE,sBAAsB;AACxB;;AAEA;EACE,mFAAmF;EACnF,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B","sourcesContent":["/* ===== Admin Instructor Approval Styles — Dark Data-Dashboard Theme ===== */\n\n/* Stats Grid */\n.admin-instructor__stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.admin-instructor__stat-card {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: 12px;\n  padding: 16px;\n  transition: all 0.2s;\n}\n\n.admin-instructor__stat-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n  transform: translateY(-2px);\n}\n\n.admin-instructor__stat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.admin-instructor__stat-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-instructor__stat-icon--warning {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-instructor__stat-icon--success {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-instructor__stat-icon--primary {\n  background: rgba(167, 139, 250, 0.1);\n  color: #a78bfa;\n}\n\n.admin-instructor__stat-icon--info {\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n}\n\n.admin-instructor__stat-label {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n  margin-bottom: 4px;\n}\n\n.admin-instructor__stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--admin-text-primary);\n}\n\n/* Tabs */\n.admin-instructor__tabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 20px;\n  padding: 3px;\n  background: var(--admin-surface);\n  border-radius: 10px;\n  width: fit-content;\n}\n\n.admin-instructor__tab {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-instructor__tab:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-primary);\n}\n\n.admin-instructor__tab--active {\n  background: var(--admin-border);\n  color: var(--admin-text-primary);\n}\n\n.admin-instructor__tab--active:hover {\n  background: var(--admin-border);\n  color: var(--admin-text-primary);\n}\n\n.admin-instructor__tab-badge {\n  padding: 2px 6px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-secondary);\n}\n\n.admin-instructor__tab--active .admin-instructor__tab-badge {\n  background: rgba(167, 139, 250, 0.2);\n  color: inherit;\n}\n\n/* Card Container */\n.admin-instructor__card-container {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.admin-instructor__card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-instructor__card-title {\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--admin-text-primary);\n}\n\n.admin-instructor__card-body {\n  padding: 20px;\n}\n\n/* Search Input */\n.admin-instructor__search-input {\n  width: 250px;\n  padding: 8px 12px 8px 36px;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  font-size: 13px;\n  color: var(--admin-text-primary);\n  background: var(--admin-bg) url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Ccircle cx='11' cy='11' r='8'/%3E%3Cpath d='m21 21-4.35-4.35'/%3E%3C/svg%3E\") 10px center no-repeat;\n  transition: all 0.2s;\n}\n\n.admin-instructor__search-input:focus {\n  outline: none;\n  border-color: #a78bfa;\n  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);\n}\n\n.admin-instructor__search-input::placeholder {\n  color: var(--admin-text-muted);\n}\n\n/* Instructor Cards */\n.admin-instructor__card {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 16px;\n  transition: all 0.2s;\n}\n\n.admin-instructor__card:last-child {\n  margin-bottom: 0;\n}\n\n.admin-instructor__card:hover {\n  border-color: var(--admin-text-dim);\n}\n\n.admin-instructor__card--pending {\n  border-left: 2px solid var(--admin-warning);\n}\n\n.admin-instructor__card--approved {\n  border-left: 2px solid var(--admin-success);\n}\n\n.admin-instructor__card--rejected {\n  border-left: 2px solid var(--admin-error);\n}\n\n.admin-instructor__card .admin-instructor__card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  padding: 0;\n  border: none;\n  background: transparent;\n}\n\n.admin-instructor__profile {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.admin-instructor__avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, var(--admin-border), var(--admin-text-dim));\n  color: var(--admin-text-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.admin-instructor__avatar--approved {\n  background: linear-gradient(135deg, var(--admin-success), #22c55e);\n  color: var(--admin-bg);\n}\n\n.admin-instructor__avatar--rejected {\n  background: linear-gradient(135deg, var(--admin-text-muted), var(--admin-text-dim));\n  color: var(--admin-text-primary);\n}\n\n.admin-instructor__name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 2px;\n}\n\n.admin-instructor__info h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n  margin: 0;\n}\n\n.admin-instructor__role-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.admin-instructor__role-badge--partner {\n  background: rgba(167, 139, 250, 0.15);\n  color: #a78bfa;\n}\n\n.admin-instructor__role-badge--assistant {\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n}\n\n.admin-instructor__info p {\n  font-size: 13px;\n  color: var(--admin-text-muted);\n  margin: 0;\n}\n\n.admin-instructor__status-badge {\n  padding: 5px 12px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.admin-instructor__status-badge--pending {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-instructor__status-badge--approved {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-instructor__status-badge--rejected {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n/* Details */\n.admin-instructor__details {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  padding: 14px;\n  background: var(--admin-bg);\n  border-radius: 8px;\n}\n\n.admin-instructor__details--has-actions {\n  margin-bottom: 16px;\n}\n\n.admin-instructor__detail-item {\n  text-align: center;\n}\n\n.admin-instructor__detail-label {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  margin-bottom: 4px;\n}\n\n.admin-instructor__detail-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-instructor__detail-value--success {\n  color: var(--admin-success);\n}\n\n.admin-instructor__detail-value--error {\n  color: var(--admin-error);\n}\n\n.admin-instructor__field-tag {\n  display: inline-block;\n  padding: 3px 8px;\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n/* Actions */\n.admin-instructor__actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  padding-top: 16px;\n  border-top: 1px solid var(--admin-border);\n}\n\n.admin-instructor__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-instructor__btn--success {\n  background: var(--admin-success);\n  color: var(--admin-bg);\n}\n\n.admin-instructor__btn--success:hover {\n  background: #22c55e;\n  box-shadow: 0 4px 12px var(--admin-success-bg);\n}\n\n.admin-instructor__btn--danger {\n  background: var(--admin-error);\n  color: #fff;\n  border: none;\n}\n\n.admin-instructor__btn--danger:hover {\n  background: #ef4444;\n  box-shadow: 0 4px 12px var(--admin-error-bg);\n}\n\n.admin-instructor__btn--secondary {\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  color: var(--admin-text-primary);\n}\n\n.admin-instructor__btn--secondary:hover {\n  background: var(--admin-surface-hover);\n  border-color: var(--admin-text-dim);\n}\n\n/* Rejection Reason */\n.admin-instructor__reject-reason {\n  margin-top: 16px;\n  padding: 12px;\n  background: var(--admin-error-bg);\n  border: 1px solid rgba(248, 113, 113, 0.2);\n  border-radius: 8px;\n}\n\n.admin-instructor__reject-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--admin-error);\n  margin-bottom: 4px;\n}\n\n.admin-instructor__reject-text {\n  font-size: 13px;\n  color: var(--admin-text-secondary);\n  line-height: 1.5;\n}\n\n/* Empty State */\n.admin-instructor__empty-state {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.admin-instructor__empty-icon {\n  width: 48px;\n  height: 48px;\n  margin: 0 auto 16px;\n  color: var(--admin-text-muted);\n  stroke-width: 1.5;\n  stroke: currentColor;\n  fill: none;\n}\n\n.admin-instructor__empty-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--admin-text-secondary);\n  margin-bottom: 8px;\n}\n\n.admin-instructor__empty-desc {\n  font-size: 13px;\n  color: var(--admin-text-muted);\n}\n\n/* Modal */\n.admin-instructor__modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-instructor__modal {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: 16px;\n  width: 100%;\n  max-width: 480px;\n  overflow: hidden;\n}\n\n.admin-instructor__modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-instructor__modal-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-instructor__modal-close {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  font-size: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--admin-text-secondary);\n  transition: all 0.2s;\n}\n\n.admin-instructor__modal-close:hover {\n  background: var(--admin-border);\n  color: var(--admin-text-primary);\n}\n\n.admin-instructor__modal-body {\n  padding: 24px;\n}\n\n.admin-instructor__modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--admin-border);\n}\n\n/* Form Elements */\n.admin-instructor__form-group {\n  margin-bottom: 16px;\n}\n\n.admin-instructor__form-group:last-child {\n  margin-bottom: 0;\n}\n\n.admin-instructor__form-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  margin-bottom: 6px;\n}\n\n.admin-instructor__form-input,\n.admin-instructor__form-select {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  font-size: 14px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  transition: all 0.2s;\n}\n\n.admin-instructor__form-input:focus,\n.admin-instructor__form-select:focus {\n  outline: none;\n  border-color: #a78bfa;\n  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);\n}\n\n.admin-instructor__form-textarea {\n  width: 100%;\n  min-height: 100px;\n  padding: 10px 14px;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  font-size: 14px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  font-family: inherit;\n  resize: vertical;\n  transition: all 0.2s;\n}\n\n.admin-instructor__form-textarea:focus {\n  outline: none;\n  border-color: #a78bfa;\n  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);\n}\n\n.admin-instructor__form-textarea::placeholder {\n  color: var(--admin-text-muted);\n}\n\n.admin-instructor__role-options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.admin-instructor__role-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-instructor__role-option:hover {\n  border-color: #a78bfa;\n  background: rgba(167, 139, 250, 0.05);\n}\n\n.admin-instructor__role-option input[type=\"radio\"] {\n  accent-color: #a78bfa;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.admin-instructor__role-option-label {\n  font-size: 14px;\n  color: var(--admin-text-primary);\n  cursor: pointer;\n}\n\n.admin-instructor__warning-box {\n  padding: 12px;\n  background: var(--admin-warning-bg);\n  border: 1px solid rgba(251, 146, 60, 0.25);\n  border-radius: 8px;\n  font-size: 12px;\n  color: var(--admin-warning);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
